import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';

const baseUrl = `${environment.apiBaseUrl}platform/widgets`;

@Injectable({
  providedIn: SharedModule
})
export class WidgetService {

  constructor(private http: HttpClient) { }

  get(id: string, date?: string): Observable<Widget.WidgetModel> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    let params = new HttpParams();

    if (date) {
      params = params.append('fromDate', date);
    }

    return this.http.get<Widget.WidgetModel>(`${baseUrl}/${id}`, {headers, params});
  }

  fields(id: string): Observable<Widget.FieldsModel> {
    return this.http.get<Widget.FieldsModel>(`${baseUrl}/${id}/widget-templates`);
  }

  update(widget: any): Observable<any> {
    return this.http.put<any>(`${baseUrl}/${widget.id}`, widget);
  }

  delete(widgetId: any): Observable<any> {
    return this.http.delete<any>(`${baseUrl}/${widgetId}`);
  }

  updateNote(widgetId: string, data: any): Observable<any> {
    return this.http.put<any>(`${baseUrl}/${widgetId}/note`, data);
  }

  duplicate(widgetId: any): Observable<any> {
    return this.http.post<any>(`${baseUrl}/${widgetId}/duplicate`, widgetId);
  }
}
